import React, { useState, useEffect } from "react";

import {
  useNavigate,
  useNavigation,
  useActionData,
  Form,
  Link,
} from "react-router-dom";

import axios from "axios";

import PropagateLoader from "react-spinners/PropagateLoader";

import {
  Card,
  Col,
  Button,
  Row,
  Container,
  Form as FormBS,
  ListGroup,
  ListGroupItem,
} from "react-bootstrap";

/**
 * @author
 * @function Home
 **/

const getValue = (name) => {
  const val = localStorage.getItem(name);
  if (val === undefined || val === null) {
    return "";
  } else {
    return val;
  }
};

const Home = ({ jwt }) => {
  const [orgId, setOrgId] = useState(getValue("orgId"));
  const [orgName, setOrgName] = useState(getValue("orgName"));
  const [email, setEmail] = useState(getValue("email"));
  const [userId, setUserId] = useState(getValue("userId"));
  const [firstName, setFirstName] = useState(getValue("firstName"));
  const [lastName, setLastName] = useState(getValue("lastName"));

  const navigation = useNavigation();
  const navigate = useNavigate();
  const actionData = useActionData();
  useEffect(() => {
    if (!jwt) {
      navigate("/");
    }
  }, [jwt, navigate]);

  return (
    <>
      <div>
        <Container>
          <Row className="d-flex justify-content-center mt-5">
            <Col md={8} lg={6} xs={12}>
              <h2 className="fw-bold mb-2 text-uppercase ">User Search</h2>
              <div className="mb-3">
                <Form method="post" action="/home">
                  <FormBS.Group className="mb-3" controlId="formBasicEmail">
                    <FormBS.Label className="text-center">
                      Email address
                    </FormBS.Label>
                    <FormBS.Control
                      type="email"
                      placeholder="Enter email"
                      name="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </FormBS.Group>
                  <h4 className="text-secondary">OR</h4>
                  <FormBS.Group className="mb-3" controlId="formBasicUserId">
                    <FormBS.Label className="text-center">User Id</FormBS.Label>
                    <FormBS.Control
                      type="text"
                      placeholder="Enter User Id"
                      name="userid"
                      value={userId}
                      onChange={(e) => setUserId(e.target.value)}
                    />
                  </FormBS.Group>
                  <h4 className="text-secondary">OR</h4>
                  <Row>
                    <Col>
                      <FormBS.Group
                        className="mb-3"
                        controlId="formBasicFirstname"
                      >
                        <FormBS.Label className="text-center">
                          First Name
                        </FormBS.Label>
                        <FormBS.Control
                          type="text"
                          placeholder="Enter First Name"
                          name="firstName"
                          value={firstName}
                          onChange={(e) => setFirstName(e.target.value)}
                        />
                      </FormBS.Group>
                    </Col>
                    <Col>
                      <FormBS.Group
                        className="mb-3"
                        controlId="formBasicLastName"
                      >
                        <FormBS.Label className="text-center">
                          Last Name
                        </FormBS.Label>
                        <FormBS.Control
                          type="text"
                          placeholder="Enter Last Name"
                          name="lastName"
                          value={lastName}
                          onChange={(e) => setLastName(e.target.value)}
                        />
                      </FormBS.Group>
                    </Col>
                  </Row>
                  <h4 className="text-secondary">OR</h4>

                  <FormBS.Group className="mb-3" controlId="formBasicOrgId">
                    <FormBS.Label className="text-center">
                      Organization Id
                    </FormBS.Label>
                    <FormBS.Control
                      type="text"
                      placeholder="Enter organization id"
                      name="orgId"
                      value={orgId}
                      onChange={(e) => setOrgId(e.target.value)}
                    />
                  </FormBS.Group>
                  <h4 className="text-secondary">OR</h4>
                  <FormBS.Group className="mb-3" controlId="formBasicOrgName">
                    <FormBS.Label className="text-center">
                      Organization Name
                    </FormBS.Label>
                    <FormBS.Control
                      type="text"
                      placeholder="Enter organization name"
                      name="orgName"
                      value={orgName}
                      onChange={(e) => setOrgName(e.target.value)}
                    />
                  </FormBS.Group>

                  <div className="d-grid">
                    {actionData && actionData.status === "Failed" && (
                      <p style={{ textAlign: "center" }}>
                        {actionData.message}
                      </p>
                    )}
                    {actionData && actionData.status === "Success" && (
                      <p>Found Results</p>
                    )}
                    {navigation.state === "submitting" && (
                      <>
                        <p style={{ textAlign: "center" }}>Searching in...</p>
                        <PropagateLoader
                          color={"#36d7b7"}
                          loading={true}
                          size={15}
                          cssOverride={{
                            height: 30,
                            marginLeft: "auto",
                            marginRight: "auto",
                          }}
                          aria-label="Loading Spinner"
                          data-testid="loader"
                        />
                      </>
                    )}
                    <Button
                      variant="primary"
                      type="submit"
                      disabled={navigation.state === "submitting"}
                    >
                      Search
                    </Button>
                  </div>
                </Form>
              </div>
            </Col>
          </Row>
          {actionData && actionData.status === "Success" && (
            <>
              <ListGroup className="shadow">
                <div>
                  {actionData.data.users.map((user, index) => (
                    <ListGroupItem
                      key={user.userId}
                      style={{
                        background: index % 2 === 0 ? "" : "lightgrey",
                      }}
                    >
                      <Row>
                        <Col className="col-10">
                          User Id: {user.userId} {user.email}
                        </Col>
                        <Col className="col-2 text-end">
                          <Link to={"/techopsTool/user/" + user.userId}>
                            Details
                          </Link>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          {user.firstName} {user.lastName}
                        </Col>
                      </Row>
                    </ListGroupItem>
                  ))}
                  {actionData.data.organizations.map((organization, index) => (
                    <ListGroupItem
                      key={organization.orgId}
                      style={{
                        background: index % 2 === 0 ? "" : "lightgrey",
                      }}
                    >
                      <Row>
                        <Col className="col-10">
                          OrgId: {organization.orgId}
                        </Col>
                        <Col className="col-2 text-end">
                          <Link
                            to={
                              "/techopsTool/organization/" + organization.orgId
                            }
                          >
                            Details
                          </Link>
                        </Col>
                      </Row>
                      <Row>
                        <Col>{organization.orgName}</Col>
                      </Row>
                    </ListGroupItem>
                  ))}
                </div>
              </ListGroup>
            </>
          )}
        </Container>
      </div>
    </>
  );
};

export default Home;

export async function action({ request, params }) {
  let jwtinfo = localStorage.getItem("prod-ftjwt");

  const formData = await request.formData();

  const orgId = formData.get("orgId").trim();
  const orgName = formData.get("orgName").trim();
  const email = formData.get("email").trim();
  const userId = formData.get("userid").trim();
  const firstName = formData.get("firstName").trim();
  const lastName = formData.get("lastName").trim();

  if (!email && !userId && !firstName && !lastName && !orgId && !orgName) {
    return {
      status: "Failed",
      message:
        "Missing email or user id or first/last name or org Id or org name",
    };
  }

  // Save these values
  localStorage.setItem("orgId", orgId);
  localStorage.setItem("orgName", orgName);
  localStorage.setItem("email", email);
  localStorage.setItem("userId", userId);
  localStorage.setItem("firstName", firstName);
  localStorage.setItem("lastName", lastName);

  const postData = {
    orgId: orgId,
    orgName: orgName,
    email: email,
    userId: userId,
    firstName: firstName,
    lastName: lastName,
  };

  //console.log("jwtinfo:" + jwtinfo);
  //console.log(JSON.stringify(postData));

  const response = await axios.post("/api/v1/search", postData, {
    headers: {
      "Content-Type": "application/json",
      apikey: "xxyyzz",
      token: jwtinfo,
    },
  });

  if (response.status !== 200) {
    //return { isError: true, message: "Error" };
  } else {
    const resData = response.data;

    return { status: "Success", message: "Found Results", data: response.data };
  }

  return { status: "failed", message: "Bad Search Request" };
}
